import { useEffect, useMemo, useRef, useState } from "react";
import { getPathDatabaseByRole } from "../actions/auth";
import { useDispatchApp } from "../lib/redux";
import { collectAlertItemIds } from "../utils/campaignAlerts";
import { fetchAlertItemStatuses } from "../utils/campaignAlertItemStatus";

const EMPTY_ITEM_STATUSES = {
  ad: {},
  adGroup: {},
  assetsGroup: {},
};

const toIdsKey = (campaigns) => {
  const ids = collectAlertItemIds(campaigns);
  return JSON.stringify({
    adIDs: [...ids.adIDs].sort(),
    adGroupIDs: [...ids.adGroupIDs].sort(),
    assetsGroupIDs: [...ids.assetsGroupIDs].sort(),
  });
};

const useCampaignAlertItemStatuses = (campaigns = {}) => {
  const dispatch = useDispatchApp();
  const campaignsRef = useRef(campaigns);
  const [itemStatuses, setItemStatuses] = useState(EMPTY_ITEM_STATUSES);
  const idsKey = useMemo(() => toIdsKey(campaigns), [campaigns]);

  campaignsRef.current = campaigns;

  useEffect(() => {
    let cancelled = false;
    const ids = JSON.parse(idsKey);
    const hasIds =
      ids.adIDs.length > 0 ||
      ids.adGroupIDs.length > 0 ||
      ids.assetsGroupIDs.length > 0;

    if (!hasIds) {
      setItemStatuses(EMPTY_ITEM_STATUSES);
      return undefined;
    }

    const load = async () => {
      const { pathAds, pathAdSets, pathAssetsGroups } = dispatch(
        getPathDatabaseByRole()
      );
      const nextStatuses = await fetchAlertItemStatuses({
        campaigns: campaignsRef.current,
        paths: { pathAds, pathAdSets, pathAssetsGroups },
      });

      if (!cancelled) {
        setItemStatuses(nextStatuses);
      }
    };

    load();

    return () => {
      cancelled = true;
    };
  }, [dispatch, idsKey]);

  return itemStatuses;
};

export default useCampaignAlertItemStatuses;
